<h3>DE CIFRIS SCHOLA LATINA</h3>
<h5>Comitato organizzatore</h5>
<ul>
	<li> Riccardo Aragona, Università dell'Aquila;</li>
	<li> Giulio Codogni, Università Tor Vergata;</li>
	<li> Michela Iezzi, Banca d'Italia;</li>
	<li> Francesca Merola, Università degli Studi Roma Tre;</li>
	<li> Marco Pedicini, Università degli Studi Roma Tre;</li>
	<li> Daniele Venturi, Sapienza Università di Roma.</li>
</ul>


<h4><a>SEMINARI RECENTI</a></h4>
<div>
	<p class="warning">Avviso: causa dell'emergenza Coronavirus (Covid-19) organizzeremo i prossimi eventi in webinar.
	</p>
	<ul>
		<li>
			<b> 31 Maggio 2022 - 14:30</b>
			<ul>
				<li>
					<b>Annamaria Iezzi</b> -- Università di Napoli <br>
					<i>"Computing the endomorphism ring of a supersingular elliptic curve"</i><br>
					<a href="../../../assets/attivita/seminariLocali/deCifris
								ScholaLatina/ALLEGATO 4_Iezzi-ScholaLatina.pdf">Locandina</a> --
					<a href="../../../assets/attivita/seminariLocali/deCifrisSchola
								Latina/Iezzi_31_maggio.pdf">Slide</a>
				</li>
			</ul>
		</li>
		<li>
			<b> 13 Aprile 2022</b> -- ore 15:00
			<ul>
				<li>
					<b>Marco Cesati</b> -- Università di Roma Tor Vergata<br>
					<i>"A new idea for RSA backdoors"</i><br>
					<a href="../../../assets/attivita/seminariLocali/deCifris
								ScholaLatina/Cesati-ScholaLatina-13.04.2022.docx-3.pdf">Locandina</a> --
					<a href="../../../assets/attivita/seminariLocali/deCifris
								ScholaLatina/Allegato2_ScholaLatina_SLIDE_Cesati_1304.pdf">Slide</a> --
					<a href="https://www.youtube.com/watch?v=-KHZn0ttO5w">Video</a>
				</li>
			</ul>
		</li>
		<li>
			<b> 15 Febbraio 2022</b>
			<ul>
				<li>
					<b>Luca De Feo</b> -- IBM Zurigo <br>
					<i>"Crittografia a Base di Isogenie"</i><br>
					<a href="../../../assets/attivita/seminariLocali/deCifris
								ScholaLatina/DeFeo15Febbraio.pdf">Locandina</a> --
					<a href="../../../assets/attivita/seminariLocali/deCifrisSchola
								Latina/ALLEGATO 1-DE FEO-2022-02-15-rome.pdf">Slide</a> --
					<a href="https://www.youtube.com/watch?v=dOKY7pgjNxw">Video</a>
				</li>
			</ul>
		</li>
	</ul>
</div>


<h4>PROSSIMI SEMINARI</h4>
<ul>

</ul>

<h4><a>SEMINARI PASSATI</a></h4>
<div>
	<ul>
		<li>
			<b>30 Novembre 2021 -- 14:30</b>
			<ul>
				<li>
					<b>Federico Pintore</b> -- Università di Bari <br>
					<i>"Collision on isogeny graphs and the security of the
						SIDH-based identification protocol"</i><br>
					<a href="../../../assets/attivita/seminariLocali/deCifrisSchola
								Latina/Pintore_Locandina_11.2021.pdf">Locandina</a> --
					<a href="../../../../assets/attivita/seminariLocali/deCifris
								ScholaLatina/Allegato3_ScholaLatina_SLIDE_Pintore - Tor 
								Vergata 31-11-2021.pdf">Slide</a>
					<br>
				</li>
			</ul>
		</li>
		<li>
			<b>18 Giugno 2021 - 11:00</b>
			<ul>
				<li>
					<b>Roberto Civino</b> -- University of L’Aquila. <br>
					<i>"On invariant subspaces in the Lai-Massey scheme
						and a primitivity reduction"</i><br>
					<a
						href="../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/RobertoCivino-ScholaLatina.pdf">Locandina</a>
					--
					<a
						href="../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/Civino_Sinopsi.pdf">Sinopsi</a>
					--
					<a href="https://www.youtube.com/watch?v=TcqHqtTB-fY" target="_blank">Video</a>
					<br>
				</li>
			</ul>
		</li>
		<li>
			<b>17 Maggio 2021 - 15:30</b>
			<ul>
				<li>
					<b>Gianira Alfarano </b> -- University of Zurich <br>
					<i>"A geometric interpretation of minimal codes"</i> <br>
					<a href="../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/Gianira.pdf">Locandina</a>
					--
					<a href="../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/Gianira2.pdf">Slide</a> --
					<a href="https://mega.nz/file/KOQ2kDrA#Yvug6FTe1eGA2b9bpam5p8MVzKbavNFePPy7i6m1WXE">Video</a>
				</li>
			</ul>
		</li>
		<li>
			<b>18 Gennaio 2021</b>
			<ul>
				<li>
					<b>Stefano Alberico</b> -- Skudo<br>
					<i>SKUDO-HSM: integrazione tra una PKI ed un chip HSM (FGPA) per
						applicazioni spaziali... e non solo</i><br>
					<a href="../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/locandina_Alberico.pdf">
						Locandina</a> --
					<a
						href="../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/slide_Alberico.pdf">Slide</a>
					--
					<a href="https://www.youtube.com/watch?v=WjG7pqFCubE">Video</a>
				</li>
			</ul>
		</li>
		<br>
		<li>
			<b>18 Dicembre 2020</b>
			<!-- <p>Dipartimento di Matematica e Fisica,  Università di Roma Tre</p> -->
			<ul>
				<li>
					<b>Ilaria Chillotti</b> -- Zama (Paris)
					<br>
					<i>Introduction to FHE and applications to machine learning</i><br>
					<a href="../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/Chillotti_Locandina.pdf">
						Locandina</a> --
					<a
						href="../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/slide_Chillotti.pdf">Slide</a>
					--
					<a href="https://www.youtube.com/watch?v=tpD_V_i63VI">Video</a>
				</li>
			</ul>
		</li>
		<br>
		<li>
			<b>14 Dicembre 2020</b>
			<!-- <p>Università Roma Tor Vergata</p> -->
			<ul>
				<li>
					<b>Edoardo Persichetti</b> -- Florida Atlantic University <br>
					<i>Code-based Cryptography and Post-Quantum Standardization</i><br>
					<a
						href="../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/14.12.2020-Persichetti.pdf">
						Locandina</a> --
					<a href="../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/slide_Persichetti.pdf">
						Slide</a> --
					<a href="https://www.youtube.com/watch?v=UNwxzwBzl2w">Video</a>
				</li>
			</ul>
		</li>
		<br>
		<li>
			<b>12 - 13 ottobre 2020</b>
			<!-- <p>Università di Roma La Sapienza</p> -->
			<ul>
				<li>
					<b>Gianluca Brian</b> -- Università di Roma La Sapienza <br>
					<i>Leakage-Resilient Non-Malleable Secret Sharing</i><br>
					<a href='../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/GianlucaBrian_locandina.pdf'
						style="color: #000080;">Locandina</a> --
					<a href="../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/13.10.2020-BRIAN-1.pdf">Slide
						1</a> --
					<a href="../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/14.10.2020-BRIAN-2.pdf">Slide
						2</a><br>
				</li>
			</ul>
		</li>
		<br>
		<li>
			<b>25 settembre 2020</b>
			<!-- <p>Università de L'Aquila - Dipartimento di Ingegneria e Scienze dell'Informazione e Matematica</p> -->
			<ul>
				<li>
					<b>Ciro Bologna</b> -- Identity and Access Management Engineer<br>
					<i>Open Banking: secure sharing of your financial data with OpenID Connect protocol</i><br>
					<a href='../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/CiroBologna_locandina.pdf'
						style="color: #000080;">Locandina</a> --
					<a
						href="../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/25.09.2020_Bologna.pdf">Slide</a>
					--
					<a href="https://youtu.be/Tifh86W1SRg">Video</a><br>
				</li>
			</ul>
		</li>
		<br>
		<li>
			<b>3 luglio 2020</b>
			<!-- <p>Dipartimento di Matematica e Fisica,  Università di Roma Tre</p> -->
			<ul>
				<li>
					<b>Francesco Pasquale</b> -- Università Roma Tor Vergata<br>
					<i>Stabilization and expansion of simple dynamic random graph models for Bitcoin-like unstructured
						P2P network</i><br>
					<a href='../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/locandina_Pasquale.pdf'
						style="color: #000080;">Locandina</a> --
					<a
						href="../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/F_Pasquale-slide.pdf">Slide</a><br>
				</li>
			</ul>
		</li>
		<br>
		<li>
			<b>26 febbraio 2020</b>
			<!-- <p>Dipartimento di Matematica e Fisica,  Università di Roma Tre</p> -->
			<ul>
				<li>
					<b>Roberto Civino</b> -- Università de L'Aquila<br>
					<i>Differential attacks using alternative operations</i><br>
					<a href='../../../../assets/attivita/seminariLocali/deCifrisSchola
								Latina/Roberto-Civino-ScholaLatina.pdf' style="color: #000080;">
						Locandina</a> --
					<a href="https://www.youtube.com/watch?v=TcqHqtTB-fY">Video</a><br>
				</li>
			</ul>
		</li>
		<br>
		<li>
			<b>27 gennaio 2020</b>
			<!-- <p>Dipartimento di Matematica e Fisica,  Università di Roma Tre</p> -->
			<ul>
				<li>
					<b>Andrea Visconti</b> -- Università di Milano<br>
					<i>SSL/TLS cryptographic protocols and their weaknesses</i><br>
					<a href='../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/Visconti-27.01.2020.pdf'
						style="color: #000080;">Locandina</a> --
					<a
						href="../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/AVISCONTI-slide.pdf">Slide</a><br>
				</li>
			</ul>
		</li>
		<br>
		<li>
			<b>10 dicembre 2019</b>
			<!-- <p>Dipartimento di Matematica e Fisica,  Università di Roma Tre</p> -->
			<ul>
				<li>
					<b>Ivan Visconti</b> -- Università di Salerno<br>
					<i>Cryptography for Blockchain</i><br>
					<a href="../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/VISCONTI-slide.pdf"
						style="color: #000080;">Locandina</a> --
					<a
						href="../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/VISCONTI-slide.pdf">Slide</a><br>
				</li>
			</ul>
		</li>
		<br>
		<li>
			<b>21 novembre 2019</b>
			<!-- <p>Dipartimento di Matematica e Fisica,  Università di Roma Tre</p> -->
			<ul>
				<li>
					<b>Lorenzo Grassi</b> -- IAIK, University of Technology of Graz<br>
					<i>SYMMETRIC CRYPTOGRAPHY: DESIGN & CRYPTANALYSIS</i><br>
					<a href='../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/grassi-locandina1.pdf'
						style="color: #000080;">Locandina</a> --
					<a
						href="../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/grassi-slide1.pdf">Slide</a><br>
				</li>
			</ul>
		</li>
		<br>
		<li>
			<b>22 novembre 2019</b>
			<!-- <p>Dipartimento di Matematica e Fisica,  Università di Roma Tre</p> -->
			<ul>
				<li>
					<b>Lorenzo Grassi</b> -- IAIK, University of Technology of Graz<br>
					<i>CRYPTANALYSIS OF AES: NEW RESulTS</i><br>
					<a href='../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/grassi-locandina2.pdf'
						style="color: #000080;">Locandina</a> --
					<a
						href="../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/grassi-slide2.pdf">Slide</a><br>
				</li>
			</ul>
		</li>
		<br>
		<li>
			<b>10-11 ottobre 2019</b>
			<!-- <p>Dipartimento di Ingegneria e Scienze dell'Informazione e Matematica, Università dell'Aquila</p> -->
			<ul>
				<li>
					<b>Francesco Pasquale</b> -- Università Roma Tor Vergata<br>
					<i>First Workshop in Algebra for Cryptography</i><br>
					<a href='../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/workshop-AQ.pdf'
						style="color: #000080;">Locandina</a><br>
				</li>
			</ul>
		</li>
		<br>
		<li>
			<b>13 maggio 2019</b>
			<!-- <p>Dipartimento di Matematica e Fisica,  Università di Roma Tre</p> -->
			<ul>
				<li>
					<b>Luca De Feo</b> -- Università de Versailles<br>
					<i>Isogeny graphs in cryptography: the good, the bad and the ugly</i><br>
					<a href='../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/defeo-locandina.pdf'
						style="color: #000080;">Locandina</a> --
					<a
						href="../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/defeo-slide.pdf">Slide</a><br>
				</li>
			</ul>
		</li>
		<br>
		<li>
			<b>15 maggio 2019</b><br>
			<!-- <p>Dipartimento di Matematica e Fisica,  Università di Roma Tre</p> -->
			<ul>
				<li>
					<b>Annalisa Errico</b> -- Presidenza del Consiglio dei Ministri<br>
					<i>Il Mestiere del Crittografo</i><br>
					<a href='../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/errico-locandina.pdf'
						style="color: #000080;">Locandina</a><br>
				</li>
			</ul>
		</li>
		<br>
		<li>
			<b>24 giugno 2019</b>
			<!-- <p>Dipartimento di Informatica, Università di Roma La Sapienza</p> -->
			<ul>
				<li>
					<b>Daniele Friolo</b> -- Dipartimento di Informatica, Università di Roma La Sapienza<br>
					<i> Affordable Security or Big Guy vs Small Guy. Does the depth of your pockets impact your
						protocols?</i><br>
					<a href='../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/friolo-locandina.pdf'
						style="color: #000080;">Locandina</a> --
					<a
						href="../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/friolo-slide.pdf">Slide</a><br>
				</li>
			</ul>
		</li>
	</ul>
</div>

<hr id="eventiPassati">
<div class="row">
	<div class="col-md-12">
		<h4>EVENTI PASSATI</h4>
		<ul>
			<li>
				<b>14 maggio 2019</b> -- Dipartimento di Ingegneria e Scienze dell'Informazione e Matematica, Università
				dell'Aquila
				<ul>
					<li>
						<b>Workshop per studenti</b>:
						<br>
						<i>Crittografia nella Vita Reale</i> --
						<a href="../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/workshop-locandina.pdf"
							style="color: #000080;">Locadina</a> <br>
						<a href="../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/cappetta-slide.pdf">SLIDE
							CAPPETTA E SPADAFORA</a> <br>
						<a href="../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/fontana-slide.pdf">SLIDE
							FONTANA</a> <br>
						<a href="../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/tarquini-slide.pdf">SLIDE
							TARQUINI</a> <br>
						<a href="../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/rosati-slide.pdf">SLIDE
							ROSATI</a><br>
						<a href="../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/carolla-slide.pdf">SLIDE
							CAROLLA</a> <br>
					</li>
				</ul>
			</li>
		</ul>
	</div>
</div>